/**
 * NLB-GW
 *
 * Contact: service@rheinenergie.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * address data of person
 */
export interface PersonalDataAddressData { 
    street?: string;
    housenumber?: string;
    /**
     * Zip Code / PLZ
     */
    postCode?: string;
    city?: string;
}

